export default "__VITE_ASSET__Gc8iVPbm__"